import { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { css } from '@emotion/react';
import { FormState, Quality } from '@definitions';
import { StateSelect } from '@components/inputs';
import { useAppTranslation } from '@hooks';
import { GetFormsPayloadType } from '@api';
import { Form } from 'common-components';

type FilterBarFormPropsType = {
  onFiltersChange?: (filters: GetFormsPayloadType) => void
  onClose?: () => void
  initValues?: GetFormsPayloadType
};

const FiltersBarForm = ({ onClose, onFiltersChange, initValues }: FilterBarFormPropsType) => {
  const { control, handleSubmit, watch, getValues, reset } = useForm<GetFormsPayloadType>({
    defaultValues: { model: {}, ...(initValues || {}) },
  });
  const { translate } = useAppTranslation();

  useEffect(() => {
    reset(initValues);
  }, [initValues]);

  const onSubmit = () => {
    const data = getValues();
    onFiltersChange && onFiltersChange(data);
    onClose && onClose();
  };

  useEffect(() => {
    const subscription = watch(() => handleSubmit(onSubmit)());
    return () => subscription.unsubscribe();
  }, [watch()]);

  return (
    <Form onFinish={handleSubmit(onSubmit)} css={$form}>
      <Controller
        name={'model.quality'}
        control={control}
        render={({ field }) => (
          <StateSelect
            values={Quality}
            labelTxKey={'quality'}
            placeholder={translate('common.quality')}
            onChange={field.onChange}
            value={field.value}
            style={{ width: 200 }}
          />
        )}
      />
      <Controller
        name={'model.state'}
        control={control}
        render={({ field }) => (
          <StateSelect
            values={FormState}
            labelTxKey={'formState'}
            placeholder={translate('common.state')}
            onChange={field.onChange}
            value={field.value}
            style={{ width: 200 }}
          />
        )}
      />
    </Form>
  );
};

const $form = css`
  display: flex;
  gap: 8px;
  width: 100%;
`;

export default FiltersBarForm;
